import { isRouteErrorResponse, Link, useRouteError } from 'react-router';

/** Route-level error boundary: replaces React Router's developer screen with a recoverable message. */
export function RouteErrorPage() {
  const err = useRouteError();
  const message = isRouteErrorResponse(err)
    ? `${err.status} ${err.statusText}`
    : err instanceof Error
      ? err.message
      : String(err);
  return (
    <div className="mx-auto max-w-xl space-y-3 px-4 py-16">
      <h1 className="text-xl font-semibold">Something went wrong</h1>
      <p className="rounded-md bg-red-50 p-3 font-mono text-xs text-red-800">{message}</p>
      <div className="flex gap-3 text-sm">
        <button className="text-emerald-700 underline" onClick={() => window.location.reload()}>
          Reload
        </button>
        <Link className="text-emerald-700 underline" to="/">
          Home
        </Link>
      </div>
    </div>
  );
}
